/* PB DUALITY SWEEP (PB-1186), for sections/pb-duality.liquid with "Scroll sweep" on.
   Same approach as the magnet light sweep (assets/pb-light-sweep.js): the section's screen is pinned with
   position:sticky on a tall track and everything is scrubbed by scroll, no timers.
   - A..B: the second copy (section colour, second option, second photo) wipes up from the bottom over the first
     (light ground, first option, first photo). The layer moves up while its contents move down by the same amount,
     so text, switch and photo never move; they change colour and photo as the edge passes them.
   - The switch thumb slides across while the edge passes the switch (both copies, so it is one continuous slide);
     the pressed state flips at the halfway point.
   - A tap on the switch scrolls to that state. Scroll up reverses everything.
   Transform only, one rAF per scroll reading only scrollY against cached offsets (measured on load, real resize
   and when the section comes near), no page-level state, height-only resizes (iOS toolbar) ignored.
   The inline script in the section decides whether the sweep runs (.pbd--sweep) and owns the pressed state. */
(function () {
  if (window.__pbdSweepBoot) { window.__pbdSweepBoot(); return; }
  var A = 0.06, B = 0.8;   /* track fractions: the wipe; the finished state holds after B */
  function cl(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function ss(a, b, x) { var t = cl((x - a) / (b - a)); return t * t * (3 - 2 * t); }

  function boot(s) {
    if (s.__pbdSweep || !s.classList.contains('pbd--sweep')) return;
    var pin = s.querySelector('.pbd__pin');
    var lays = [].slice.call(s.querySelectorAll('[data-pbd-b]'));
    var inners = lays.map(function (l) { return l.querySelector('[data-pbd-bin]'); });
    if (!pin || !lays.length || inners.indexOf(null) > -1) return;
    var n = lays.length, MODES = ['work', 'play', 'store'];   /* one wipe per extra option, one after the other */
    s.__pbdSweep = 1;
    var thumbs = [].slice.call(s.querySelectorAll('.pbd__thumb'));
    var pill = s.querySelector('.pbd__lay--a .pbd__toggle');
    var H = 1, total = 1, top0 = 0, vw = 0, vh = 0, k0 = 0.4, k1 = 0.6, lastYs = [];
    var near = !('IntersectionObserver' in window), raf = false, lastY = -1, lastT = -1, mode = '';

    function live() { return s.classList.contains('pbd--sweep'); }
    function measure() {
      vw = innerWidth; vh = innerHeight;
      if (!live()) return;
      if (getComputedStyle(pin).position !== 'sticky') { flat(); return; }
      H = pin.offsetHeight || vh;
      total = Math.max(1, s.offsetHeight - H);
      top0 = s.getBoundingClientRect().top + sy();   /* cached: the scrub reads only scrollY per frame */
      /* where the edge crosses the switch: the thumb slides while the edge passes it */
      if (pill) {
        var pr = pill.getBoundingClientRect(), qr = pin.getBoundingClientRect();
        var kc = cl(1 - ((pr.top + pr.height / 2) - qr.top) / H);
        k0 = cl(kc - 0.14); k1 = cl(kc + 0.14);
      }
      lastYs = []; lastT = -1;
    }
    function flat() {
      lays.forEach(function (l, i) { l.style.transform = inners[i].style.transform = ''; });
      thumbs.forEach(function (t) { t.style.transform = ''; });
      if (s.__pbdFlat) s.__pbdFlat();
    }
    function sy() { return window.scrollY || window.pageYOffset || 0; }
    function progress() { return cl((sy() - top0) / total); }
    function frame() {
      raf = false;
      if (!live()) return;
      var K = cl((progress() - A) / (B - A)), t = 0;
      for (var i = 0; i < n; i++) {
        var k = cl(K * n - i), y = Math.round((1 - k) * H);
        t += ss(k0, k1, k);
        if (y !== lastYs[i]) {
          lastYs[i] = y;
          lays[i].style.transform = 'translate3d(0,' + y + 'px,0)';
          inners[i].style.transform = 'translate3d(0,' + (-y) + 'px,0)';
        }
      }
      t = Math.round(t * 200) / 200;
      if (t !== lastT) {
        lastT = t;
        var tf = t ? 'translate3d(' + (t * 100).toFixed(1) + '%,0,0)' : '';
        for (var j = 0; j < thumbs.length; j++) thumbs[j].style.transform = tf;
      }
      var m = MODES[Math.min(n, Math.round(t))];
      if (m !== mode) { mode = m; if (s.__pbdPressed) s.__pbdPressed(m); }
      s._pbdK = K; s._pbdT = t;
    }
    function kick() { if (!raf) { raf = true; requestAnimationFrame(frame); } }
    function onResize() {
      if (innerWidth === vw && Math.abs(innerHeight - vh) <= 150) return;   /* the iOS toolbar sliding: ignore */
      measure(); kick();
    }
    /* a tap on the switch: scroll to the point where that state is fully on screen */
    s.__pbdGo = function (m) {
      var i = Math.max(0, MODES.indexOf(m)), p = A + (B - A) * Math.min(i, n) / n;
      p = i === 0 ? Math.max(0, A - 0.03) : i >= n ? Math.min(1, B + 0.05) : p;
      var top = top0 + p * total;
      try { window.scrollTo({ top: Math.round(top), behavior: 'smooth' }); } catch (e) { window.scrollTo(0, Math.round(top)); }
    };

    measure(); frame();
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { near = es[0].isIntersecting; if (near) { measure(); kick(); } }, { rootMargin: '50% 0px 50% 0px' }).observe(s);
    }
    /* content above that loads late moves the section: re-measure, but only while it is off screen (never mid-scrub) */
    if ('ResizeObserver' in window) {
      var bw = -1, bh = -1;
      new ResizeObserver(function () {
        var b = document.body; if (!b || near) return;
        if (b.offsetWidth === bw && b.offsetHeight === bh) return;
        bw = b.offsetWidth; bh = b.offsetHeight; requestAnimationFrame(measure);
      }).observe(document.body);
    }
    addEventListener('scroll', function () { if (near) kick(); }, { passive: true });
    addEventListener('resize', onResize, { passive: true });
    addEventListener('load', function () { measure(); kick(); });
    addEventListener('pageshow', function () { measure(); kick(); });
  }
  function bootAll() { [].forEach.call(document.querySelectorAll('[data-pbd-sweep]'), boot); }
  window.__pbdSweepBoot = bootAll;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll); else bootAll();
  document.addEventListener('shopify:section:load', bootAll);
})();
